import { MenuNameType } from "../../Enums/ChoiceEnums"

export enum LogoSize {
    Small = "S",
    Medium = "M",
    Large = "L"
}

export interface ICompanyFolderUsageItem {
    menuNameId: MenuNameType,
    menuId: number,
    documentCount: number,
    documentSize: number,
    documentPath: string
}

export interface ICompanyFolderUsageResults {
    folderList:  Array<ICompanyFolderUsageItem>
}

export interface IDocumentImageBase64Response {
    imageBase64: string,
    mimeType: string,
    imageName: string
};